import Formatter from '@square/dashboard-utilities/utils/i18n-deprecated/formatter';

// This file has been deprecated, please use formatter service instead.

let format = null;
export function setup(FormatterService) {
  // FIXME(carden): import/inject i18n/formatter directly and remove this line:
  format = new Formatter(FormatterService);
}
export function getFormat() {
  return format;
}